import { render, staticRenderFns } from "./NewDialogTriggerBtn.vue?vue&type=template&id=a4b24ac2&scoped=true&"
import script from "./NewDialogTriggerBtn.vue?vue&type=script&lang=js&"
export * from "./NewDialogTriggerBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b24ac2",
  null
  
)

export default component.exports